export default "__VITE_ASSET__BKMUmNP2__"